import React from "react";
import designrushLogo from "../assets/logos/designrush.png";
import logoUixifyType from "../assets/logos/logo-uixify-type.webp";
import Byd from "../assets/images/Byd.svg";
import Carrefour from "../assets/images/Carrefour.svg";
import Mondelez from "../assets/images/Mondelez.svg";
import Xiaomi from "../assets/images/Xiaomi.svg";
import Suzuki from "../assets/images/Suzuki.svg";
import Zong from "../assets/images/Zong.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaBehanceSquare, FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io5";

export const Footer = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div
        className="bg-[#7366fc] pt-4 md:pt-10 overflow-hidden"
        // style={{
        //   background: `url(${bgImg})`,
        //   backgroundRepeat: "round",
        //   backgroundSize: "cover",
        // }}
      >
        <div className="w-full footer-slider-swiper">
          <Swiper
            data-aos="fade-left"
            // data-aos="fade-left"
            slidesPerView={3}
            spaceBetween={10}
            // navigation={true}
            // modules={[Navigation]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 6,
                spaceBetween: 50,
              },
            }}
            className="mySwiperThird"
          >
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Byd}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Carrefour}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] ">
                <img
                  alt={`Company logo`}
                  src={Suzuki}
                  className="object-contain w-full mx-auto"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Mondelez}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] md:pt-[8px] pt-[3px]">
                <img
                  alt={`Company logo`}
                  src={Xiaomi}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Zong}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Byd}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Carrefour}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] ">
                <img
                  alt={`Company logo`}
                  src={Suzuki}
                  className="object-contain w-full mx-auto"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Mondelez}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]  md:pt-[8px] pt-[3px]">
                <img
                  alt={`Company logo`}
                  src={Xiaomi}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Zong}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-2 md:grid-cols-7 gap-6">
            {/* Contact info */}
            <div className="flex flex-col col-span-2 gap-2">
              <h4 className="text-white font-semibold text-[20px]">
                Get in touch
              </h4>
              <div>
                <h6 className="text-white text-[15px] mb-1 tracking-wide">
                  12-C/II, Lane 6, Bukhari Comm - DHA - Karachi, 75500
                </h6>
                <a
                  href="mailto:omar.uixify@gmail.com"
                  className="text-white text-[15px] mb-1 no-underline hover:text-[#c0ff00] transition duration-200 tracking-wide"
                >
                  omar.uixify@gmail.com
                </a>

                {/* <h6 className="text-white text-[15px] mb-1">
                  +1(123) 4546-7890
                </h6> */}
                <div className="flex items-center gap-2 mt-3">
                  <a href="https://www.facebook.com/uixify" target="_blank">
                    <FaFacebookSquare className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-2xl" />
                  </a>
                  <a
                    href="https://www.instagram.com/uixify.design"
                    target="_blank"
                  >
                    <FaSquareInstagram className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-2xl" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/uixify"
                    target="_blank"
                  >
                    <FaLinkedin className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-2xl" />
                  </a>
                  <a href="https://www.behance.net/UIXIFY" target="_blank">
                    <FaBehanceSquare className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-2xl" />
                  </a>
                  {/* <a href="https://www.upwork.com/agencies/1822787120111267840/">
                    <FaSquareUpwork className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-2xl" />
                  </a> */}
                  <a
                    href="https://www.youtube.com/@UIXIFY.DESIGN"
                    target="_blank"
                  >
                    <IoLogoYoutube className="text-white hover:text-[#c0ff00] transition duration-200 hover:scale-125 text-3xl" />
                  </a>
                </div>
              </div>
            </div>
            {/* Special Links */}
            <div className="flex flex-col md:col-span-2 gap-2 md:items-center">
              <h4 className="text-white font-semibold text-[20px]">
                Site Links
              </h4>
              <div className="flex flex-col">
                {[
                  { name: "Service", to: "services" },
                  { name: "Our Work", to: "projects" },
                  { name: "Testimonial", to: "testimonials" },
                ].map((item, index) => (
                  <a
                    key={index}
                    onClick={() => scrollToSection(item.to)}
                    className="text-white text-left text-[15px] mb-1 cursor-pointer hover:underline"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Company Links */}
            <div className="hidden sm:block flex flex-col md:col-span-2 gap-2 md:items-center">
              <h4 className="text-white w-fit font-semibold text-[20px]">
                Company
              </h4>
              <div className="w-fit flex flex-col">
                {["Contact", "Team", "FAQs"].map((item, index) => (
                  <a
                    key={index}
                    className="text-white w-fit text-[15px] mb-1 cursor-pointer hover:underline"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="w-full flex  justify-center md:justify-start">
                <Link to="https://www.designrush.com">
                  <img
                    src={designrushLogo}
                    alt="Design Rush Logo"
                    className="object-contain w-auto h-[140px]"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <h2
          className="no-text-icon text-center text-[60px] md:text-[85px] xl:text-[250px] lg:text-[170px] text-transparent leading-[0.4] mt-10 md:mt-14 tracking-wide font-black"
          style={{ WebkitTextStroke: "2px #ffff" }}
        >
          UIXIFY
        </h2>
      </div>
    </>
  );
};
